import { useMemo } from 'react';
import { FilterType, IFilter } from '../../interfaces/Filter.interfaces';
import { isFilterSelectedAsAll } from '../../utils/filter/isFilterSelectedAsAll.util';
import { useAppSelector } from '../store/useStore';

interface useCheckFilterButtonActiveProps {
  filterType: FilterType;
  filter: IFilter;
}

export const useCheckFilterButtonActive = (props: useCheckFilterButtonActiveProps) => {
  const filterStates = useAppSelector((state) => state.filter[props.filterType]);

  const isFilterButtonActive = useMemo<boolean>(() => {
    let isFilterButtonActive = false;

    filterStates.globalFilters.forEach((filter) => {
      // 파라미터로 받은 필터에 대해 활성화된 옵션이 있는지 검색
      if (props.filter?.key === filter.key) {
        // 직거래는 하나도 고르지 않았거나 모두 고른 항목을 '전체'로 보아 활성으로 치지 않는다.
        if (props.filterType === 'directDealFilter' && isFilterSelectedAsAll(filter)) {
          return;
        }

        if (filter.optionType === 'radio' || filter.optionType === 'checkbox') {
          filter.options.forEach((option) => {
            // 기본 선택된 옵션을 해제한 경우도 기본값과 달라진 것이므로 활성으로 본다.
            if (option.isSelected !== Boolean(option.isDefault)) {
              isFilterButtonActive = true;
            }
          });
        } else if (filter.optionType === 'slider') {
          filter.options.forEach((option) => {
            if (option.value !== option.defaultValue) {
              isFilterButtonActive = true;
            }
          });
        }
      }

      if (
        props.filterType === 'directDealFilter' &&
        props.filter.key === 'engineOutputInPs' &&
        filter.key === 'engineOutputInPs'
      ) {
        const rowConfigFilter = filterStates.globalFilters.find((filter) => filter.key === 'rowConfig');
        const isRowConfigActive =
          rowConfigFilter &&
          !isFilterSelectedAsAll(rowConfigFilter) &&
          rowConfigFilter.options.some((option) => option.isSelected);
        if (isRowConfigActive) {
          isFilterButtonActive = true;
        }
      }
    });

    return isFilterButtonActive;
  }, [filterStates, props.filter, props.filterType]);

  return { isFilterButtonActive };
};
